/**
 * @generated SignedSource<<8b6f060db7d53dffce9d5669b82e8a7d>>
 * @relayHash de2055f79d838c6ae662c546481a203f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a0ca02317789aa09b7ec67b818534de3b2bac61f0029863077ab8e2260e3f601

import type { ConcreteRequest, Query } from 'relay-runtime';
export type preloadContentSmartLinksQuery$variables = {
  contentId: string;
};
export type preloadContentSmartLinksQuery$data = {
  readonly contentSmartLinks: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: string;
      readonly url: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type preloadContentSmartLinksQuery = {
  response: preloadContentSmartLinksQuery$data;
  variables: preloadContentSmartLinksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedSmartLinkList",
    "kind": "LinkedField",
    "name": "contentSmartLinks",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadContentSmartLinksQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadContentSmartLinksQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "de2055f79d838c6ae662c546481a203f",
    "id": "a0ca02317789aa09b7ec67b818534de3b2bac61f0029863077ab8e2260e3f601",
    "metadata": {},
    "name": "preloadContentSmartLinksQuery",
    "operationKind": "query",
    "text": "query preloadContentSmartLinksQuery($contentId:ID!){contentSmartLinks(id:$contentId){nodes{__typename,url}}}"
  }
};
})();

(node as any).hash = "b754ba4177177d2190e5f0f97831d643";

export default node;
